var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTestTubeLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1663 1.66666V3.33332H13.333V15C13.333 16.8409 11.8406 18.3333 9.99967 18.3333C8.15872 18.3333 6.66634 16.8409 6.66634 15V3.33332H5.83301V1.66666H14.1663ZM11.6663 8.33332H8.33301V15C8.33301 15.9205 9.07917 16.6667 9.99967 16.6667C10.9202 16.6667 11.6663 15.9205 11.6663 15V8.33332ZM10.833 12.5C11.2933 12.5 11.6663 12.8731 11.6663 13.3333C11.6663 13.7936 11.2933 14.1667 10.833 14.1667C10.3728 14.1667 9.99967 13.7936 9.99967 13.3333C9.99967 12.8731 10.3728 12.5 10.833 12.5ZM9.16634 9.99999C9.62659 9.99999 9.99967 10.3731 9.99967 10.8333C9.99967 11.2936 9.62659 11.6667 9.16634 11.6667C8.70609 11.6667 8.33301 11.2936 8.33301 10.8333C8.33301 10.3731 8.70609 9.99999 9.16634 9.99999ZM11.6663 3.33332H8.33301V6.66666H11.6663V3.33332Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTestTubeLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/test-tube-line.e9c923b0.svg";
export { ForwardRef as ReactComponent };